<template>
  <div class="new-container">
    <div class="new-header-box">
      <div class="user-box">
        <span>您好：
          <a-icon type="user" />{{ name }}
        </span>
        <span>
          <a-button type="primary"
                    icon="user-add"
                    @click="showAdd">
            我要招聘
          </a-button>
          <label v-for="(item, index) in menu"
                 :key="index"
                 @click="menuClick(index)"
                 :class="menuActive == index ? 'active' : ''">{{ item.name }}</label>

          <a-button type="danger"
                    icon="logout"
                    @click="logout">
            退出
          </a-button>
        </span>
      </div>
    </div>

    <div class="container-body">
      <div class="body-box">
        <router-view ref="childView"
                     @fathre="showZhaoPin"></router-view>
      </div>
    </div>

    <!-- 发布招聘信息 -->
    <a-modal title="发布招聘信息"
             :visible="addVisible"
             :width="700"
             okText="发布"
             @ok="addZhaoPin"
             cancelText="取消"
             @cancel="addCancel"
             :maskClosable="false">
      <div class="center">
        <h2>
          本年可发招聘信息{{ orgAllCount }}条，已发{{
            this.$session.orgSendCount()
          }}条，剩余{{ orgAllCount - this.$session.orgSendCount() }}条。
        </h2>
      </div>
      <a-form-model ref="addForm"
                    :model="addForm"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                    class="addForm">
        <a-col :md="24">
          <a-form-model-item label="机构名称"
                             required
                             prop="ApjgName">
            <a-input v-model="addForm.ApjgName"
                     disabled />
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item label="机构简介"
                             required>
            <!-- <a-input
              v-model="addForm.OrgIntroduce"
              v-html="addForm.OrgIntroduce"
              type="textarea"
              :maxLength="4000"
              rows="10"
            />  -->
            <WangEditor :value="addForm.OrgIntroduce"
                        @change="GetContext"></WangEditor>
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item label="工作地点"
                             required
                             prop="Province">
            <a-select ref="proSelect"
                      v-model="addForm.Province"
                      show-search
                      placeholder="请选择地点"
                      allowClear>
              <a-select-option v-for="(i, index) in ProvinceSelect"
                               :key="index"
                               :value="i.ProvinceName">
                {{ i.ProvinceName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item label="工作性质"
                             required
                             prop="IsFullTime">
            <a-radio-group v-model="addForm.IsFullTime"
                           prop="IsFullTime">
              <a-radio-button :value="1">
                专职
              </a-radio-button>
              <a-radio-button :value="2">
                兼职
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item label="岗位职责"
                             required
                             prop="Role">
            <a-select style="width: 120px"
                      v-model="addForm.Role"
                      @change="roleChange">
              <a-select-option v-for="role in roleSel"
                               :key="role">
                {{ role }}
              </a-select-option>
            </a-select>
            <a-select v-model="addForm.Duty"
                      mode="multiple"
                      notFoundContent="无"
                      :allowClear="true"
                      style="width: 240px">
              <a-select-option v-for="duty in dutySel"
                               :key="duty">
                {{ duty }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item label="职位描述"
                             required
                             prop="JobDescription">
            <a-input v-model="addForm.JobDescription"
                     type="textarea"
                     :maxLength="3000"
                     rows="10" />
            <p style="color:red;text-align: left;">
              不能超过3000个字符
            </p>
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item label="学历"
                             required
                             prop="Education">
            <a-select v-model="addForm.Education"
                      placeholder="请选择学历">
              <a-select-option value="不限">不限</a-select-option>
              <a-select-option value="大学专科">大学专科</a-select-option>
              <a-select-option value="大学本科">大学本科</a-select-option>
              <a-select-option value="研究生">研究生</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item required
                             prop="Major"
                             label="专业">
            <a-input v-model="addForm.Major"
                     type="text"
                     placeholder="专业" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item label="职称"
                             required
                             prop="Title">
            <a-select v-model="addForm.Title"
                      placeholder="请选择职称">
              <a-select-option value="不限">不限</a-select-option>
              <a-select-option value="初级职称">初级职称</a-select-option>
              <a-select-option value="中级职称">中级职称</a-select-option>
              <a-select-option value="副高级职称">副高级职称</a-select-option>
              <a-select-option value="正高级职称">正高级职称</a-select-option>
              <a-select-option value="教授级高工">教授级高工</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item label="级别"
                             required
                             prop="Level">
            <a-select v-model="addForm.Level"
                      placeholder="请选择级别">
              <a-select-option value="-1">不限</a-select-option>
              <a-select-option value="1">一级</a-select-option>
              <a-select-option value="2">二级</a-select-option>
              <a-select-option value="3">三级</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item label="年龄"
                             required
                             prop="AgeMin">
            <a-input-group compact>
              <a-input-number :min="18"
                              :max="100"
                              :precision="0"
                              v-model="addForm.AgeMin"
                              step="5" />
              ~
              <a-input-number :min="18"
                              :max="100"
                              :precision="0"
                              v-model="addForm.AgeMax"
                              step="5" />（岁）
            </a-input-group>
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item label="工作经验"
                             required
                             prop="WorkMin">
            <a-input-group compact>
              <a-input-number :min="1"
                              :max="100"
                              :precision="0"
                              v-model="addForm.WorkMin" />
              ~
              <a-input-number :min="1"
                              :max="100"
                              :precision="0"
                              v-model="addForm.WorkMax" />（年）
            </a-input-group>
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item required
                             label="薪资待遇"
                             prop="MoneyMin">
            <a-input-group compact
                           class="moneyInput">
              <span v-show="!addForm.MoneyFace">
                <a-input-number :min="0"
                                v-model="addForm.MoneyMin"
                                :precision="0"
                                step="1000" />
                ~
                <a-input-number :min="0"
                                v-model="addForm.MoneyMax"
                                :precision="0"
                                step="1000" />（元）
              </span>
              <a-checkbox @change="onMoneyChange"
                          v-model="addForm.MoneyFace"
                          style="padding-top: 6px; padding-left: 6px">
                面议
              </a-checkbox>
            </a-input-group>
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item required
                             label="招聘人数"
                             prop="Count">
            <a-input-number :min="1"
                            v-model="addForm.Count"
                            :precision="0" />（人）
          </a-form-model-item>
        </a-col>
        <!-- <a-col :md="24">
          <a-form-model-item label="社保"
                             required
                             prop="IsSheBao">
            <a-radio-group v-model="addForm.IsSheBao"
                           prop="IsSheBao">
              <a-radio-button value="true"> 有社保 </a-radio-button>
              <a-radio-button value="false"> 无社保 </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col> -->
        <a-col :md="24">
          <a-form-model-item required
                             label="联系人"
                             prop="LinkMan">
            <a-input v-model="addForm.LinkMan"
                     placeholder="联系人" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item required
                             label="手机号"
                             prop="LinkPhone">
            <a-input v-model="addForm.LinkPhone"
                     placeholder="手机号"
                     :maxLength="11" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item label="邮箱"
                             prop="LinkEmail">
            <a-input v-model="addForm.LinkEmail"
                     placeholder="邮箱" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24">
          <a-form-model-item label="微信"
                             prop="LinkWx">
            <a-input v-model="addForm.LinkWx"
                     placeholder="微信" />
          </a-form-model-item>
        </a-col>
      </a-form-model>
    </a-modal>

    <!-- 查看招聘信息 -->
    <a-modal title="查看招聘信息"
             :visible="showVisible"
             :width="850"
             okText="确定"
             @ok="showClose"
             cancelText="关闭"
             @cancel="showClose">
      <div class="ant-table ant-table-bordered">
        <div class="ant-table-body">
          <table>
            <tbody class="ant-table-tbody">
              <tr>
                <td style="width:100px;">机构名称</td>
                <td colspan="3">
                  {{ addForm.ApjgName }}
                </td>
              </tr>
              <tr>
                <td>机构简介</td>
                <td colspan="3">
                  <div v-html="addForm.OrgIntroduce"></div>
                </td>
              </tr>
              <tr>
                <td>工作地点</td>
                <td>
                  {{ addForm.Province }}
                </td>
                <td>工作性质</td>
                <td>
                  {{ addForm.IsFullTime ? "专职" : "兼职" }}
                </td>
              </tr>
              <tr>
                <td>学历</td>
                <td>
                  {{ addForm.Education }}
                </td>
                <td>专业</td>
                <td>
                  {{ addForm.Major }}
                </td>
              </tr>
              <tr>
                <td>职称</td>
                <td>
                  {{ addForm.Title }}
                </td>
                <td>级别</td>
                <td>
                  {{ this.$common.getLevel(addForm.Level) }}
                </td>
              </tr>
              <tr>
                <td>年龄</td>
                <td>{{ addForm.AgeMin }}-{{ addForm.AgeMax }}（岁）</td>
                <td>工作经验</td>
                <td>{{ addForm.WorkMin }}-{{ addForm.WorkMax }}（年）</td>
              </tr>
              <tr>
                <td>薪资待遇</td>
                <td>
                  {{
                    addForm.MoneyFace
                      ? "面议"
                      : addForm.MoneyMin + "-" + addForm.MoneyMax + "（元）"
                  }}
                </td>
                <td>招聘人数</td>
                <td>{{ addForm.Count }}（人）</td>
              </tr>
              <tr>
                <td>岗位职责</td>
                <td colspan="3">{{ addForm.Role }}：{{ addForm.Duty }}</td>
              </tr>
              <tr>
                <td>职位描述</td>
                <td colspan="3">
                  <div v-html="addForm.JobDescription"></div>
                </td>
              </tr>
              <tr>
                <!-- <td>社保
              </td>
              <td>
                <a-radio-group v-model="addForm.IsSheBao"
                               prop="IsSheBao">
                  {{ addForm.IsFullTime ? "有社保" : "无社保" }}
                </a-radio-group>
              </td> -->
                <td>联系人</td>
                <td>
                  {{ addForm.LinkMan }}
                </td>
                <td>手机号</td>
                <td>
                  {{ addForm.LinkPhone }}
                </td>
              </tr>
              <tr>
                <td>邮箱</td>
                <td>
                  {{ addForm.LinkEmail }}
                </td>
                <td>微信</td>
                <td>
                  {{ addForm.LinkWx }}
                </td>
              </tr>
              <tr>
                <td>创建时间</td>
                <td colspan="3">
                  {{
                    $moment(addForm.CreateTime).format("YYYY-MM-DD HH:mm:ss")
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { GetZhaoPin, SaveUpdateZP } from "../../api/zhaopin";
import { GetProvice } from "../../api/province";
import WangEditor from "../../components/common/WangEditor.vue";

const roleSel = ["管理人员", "技术人员"];
const dutyList = {
  管理人员: ["技术负责人", "过程控制负责人", "档案负责人", "其他"],
  技术人员: [
    "技术负责人审查",
    "过程控制负责人审查",
    "项目负责人",
    "报告编制",
    "收集资料",
    "现场勘查",
    "风险辨识与评价",
    "专业技术支持",
    "报告审核",
    "其他"
  ]
};
export default {
  name: "UILayout",
  components: {
    WangEditor
  },
  data () {
    const vlPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("不能为空"));
      } else {
        if (!/^(1[3456789]\d{9})$/.test(value)) {
          callback(new Error("手机号格式错误"));
        } else {
          callback();
        }
      }
    };
    return {
      menu: [
        { name: "应聘信息", url: "/org" },
        { name: "求职信息", url: "/org/jianli?type=1" },
        { name: "我的收藏", url: "/org/jianli?type=2" }
      ],
      menuActive: 0,
      orgAllCount: this.$session.get("orgAllCount"),
      name: this.$session.get("orgName"),
      orgType: this.$common.getOrgType(this.$session.get("orgType")),
      // 添加招聘信息页面
      addVisible: false,
      showVisible: false,
      addForm: {}, // 发布招聘信息数据存储
      wrapperCol: { span: 14 },
      labelCol: { span: 4 },
      other: "",
      roleSel,
      dutyList,
      dutySel: [],
      ProvinceSelect: [], // 省份信息
      // 验证规则
      rules: {
        LinkPhone: [
          {
            required: true,
            validator: vlPhone,
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted () {
    // 获取省份信息
    GetProvice().then(res => {
      this.ProvinceSelect = res.Data;
    });
    // 页面刷新后，导航栏定位对应导航高亮显示
    this.menu.some((item, i) => {
      let url = "";
      for (let key in this.$route.query) {
        url = this.$route.path + "?" + key + "=" + this.$route.query[key];
      }
      if (item.url == url) {
        let index = this.menu.findIndex(s => s.url == url);
        this.menuActive = index;
      }
    });
  },
  methods: {
    menuClick (index) {
      this.menuActive = index;
      this.$message.loading("加载中...");
      this.$router.push(this.menu[index].url);
    },
    showAdd () {
      // 校验发布的招聘数量
      if (
        parseInt(this.$session.orgSendCount()) >= parseInt(this.orgAllCount)
      ) {
        this.$message.error({
          content: "您发布的招聘信息数量已上限！",
          duration: 2
        });
      } else {
        this.addForm = {};
        // this.addForm.ApjgName = this.$session.orgName;  停用  未获取到当前登录机构信息
        // this.addForm.OrgIntroduce = this.$session.orgIntroduce;
        this.addForm.ApjgName = this.$session.get("orgName");
        this.addForm.OrgIntroduce = this.$session.get("orgIntroduce");
        this.addVisible = true;
      }
    },
    roleChange (val) {
      console.info(val);
      this.dutySel = this.dutyList[val];
      if (undefined !== this.addForm.Duty) {
        this.addForm.Duty = undefined;
      }
    },
    showZhaoPin (id) {
      GetZhaoPin(id, 0).then(res => {
        res.Data.JobDescription = this.$common.areaFormat(
          res.Data.JobDescription
        );
        res.Data.OrgIntroduce = this.$common.areaFormat(res.Data.OrgIntroduce);
        this.addForm = res.Data;

        // res.Data.Duty = res.Data.Duty.split('|');
        // this.addVisible = true; //编辑

        if (this.addForm.Duty != undefined && this.addForm.Duty != null) {
          this.addForm.Duty = this.addForm.Duty.replace(/\|/g, "、");
        }
        this.showVisible = true; //查看
      });
    },
    showClose () {
      this.showVisible = false;
    },
    logout () {
      this.$router.push("/");
      this.$cookie.clearCookie("apryPassport");
      this.$cookie.clearCookie("adminPassport");
      this.$session.clear();
    },
    addCheck () {
      let isPass = false;
      if (
        this.addForm.OrgIntroduce == undefined ||
        this.addForm.OrgIntroduce == null ||
        this.addForm.OrgIntroduce == ""
      ) {
        this.$message.error({
          content: "请输入机构简介!",
          duration: 2
        });
      } else if (
        this.addForm.Duty == undefined ||
        this.addForm.Duty == null ||
        this.addForm.Duty == ""
      ) {
        this.$message.error({
          content: "请输入岗位职责!",
          duration: 2
        });
      } else if (
        parseInt(this.addForm.AgeMin) >= parseInt(this.addForm.AgeMax)
      ) {
        this.$message.error({
          content: "年龄范围请重新输入!",
          duration: 2
        });
      } else if (
        parseInt(this.addForm.WorkMin) >= parseInt(this.addForm.WorkMax)
      ) {
        this.$message.error({
          content: "工作经验请重新输入!",
          duration: 2
        });
      } else if (
        !this.addForm.MoneyFace &&
        (isNaN(parseInt(this.addForm.MoneyMin)) ||
          isNaN(parseInt(this.addForm.MoneyMax)) ||
          parseInt(this.addForm.MoneyMin) >= parseInt(this.addForm.MoneyMax))
      ) {
        this.$message.error({
          content: "薪资待遇请重新输入!",
          duration: 2
        });
      } else {
        isPass = true;
      }
      return isPass;
    },
    addZhaoPin (e) {
      e.target.disabled = true;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (this.addCheck()) {
            this.$message.loading({ content: "发布中，请稍后..." });
            this.addForm.ApjgId = this.$session.get("orgId");
            this.addForm.IsPublish = true;
            this.addForm.IsFullTime =
              this.addForm.IsFullTime == 1 ? true : false;
            if (typeof this.addForm.Duty == "object") {
              this.addForm.Duty = this.addForm.Duty.join("|");
            }
            SaveUpdateZP(this.addForm).then(res => {
              if (res.Data) {
                this.$message.success({
                  content: "发布成功!"
                });
                this.addVisible = false;
                this.$session.orgSendCount(1);
                this.$refs["childView"].InitZhaoPin();
              } else {
                this.addVisible = true;
                this.$message.error("请求失败");
              }
            });
          }
        } else {
          this.$refs.proSelect.focus();
          this.$message.error({
            content: "提交失败，请完善招聘所有必填信息!",
            duration: 2
          });
          this.$refs.proSelect.blur();
          return false;
        }
        e.target.disabled = false;
      });
    },
    GetContext (val) {
      this.addForm.OrgIntroduce = val;
    },
    addCancel (e) {
      this.$refs.addForm.resetFields();
      this.addVisible = false;
    },
    onMoneyChange (e) {
      this.addForm.MoneyFace === true ? false : true;
      this.moneyInputShow = false;
      if (this.moneyInputShow) {
        this.addForm.MoneyMin = null;
        this.addForm.MoneyMax = null;
      } else {
        this.addForm.MoneyMin = 0;
        this.addForm.MoneyMax = 0;
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "./UIlayout.less";
.addForm .ant-form-item {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/OrgLayout.vue